module.exports = __webpack_public_path__ + "img/西瓜14.6d2f01f8.png";